import React from 'react';

const Accessibility = () => {
    return (
        <div>
            <h2>Accessibility</h2>
            <p>This is the Accessibility page.</p>
        </div>
    );
};

export default Accessibility;
